import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { AuthGuardService } from '@core/index';
import { AdminGuardService } from './core/security/services/auth/admin.guard.service';

import { PortalEmpresaModulePreloadingStrategy } from '@services';

const routes: Routes = [
	{
		path: '',
		redirectTo: 'home',
		pathMatch: 'full',
	},
	{
		path: 'home',
		data: {
			title: '',
			description: '',
			breadcrumbs: 'Home',
			preload: true,
		},
		loadChildren: () => import('./modules/home/home.module').then(mod => mod.HomeModule),
	},
	{
		path: 'faqs',
		data: {
			title: 'FAQs',
			description: 'Preguntas Frecuentes',
			breadcrumbs: 'Preguntas Frecuentes',
			preload: true,
		},
		loadChildren: () => import('./modules/faq/faq.module').then(mod => mod.FaqModule),
	},

	{
		path: 'empresas',
		data: {
			title: 'Empresas',
			description: 'Seleccion de Empresa',
			breadcrumbs: 'Seleccion de Empresa',
			preload: true,
		},
		canActivate: [AuthGuardService],
		loadChildren: () => import('src/app/modules/empresa/empresa.module').then(mod => mod.EmpresaModule),
	},
	{
		path: 'admin',
		data: {
			title: 'Consultas',
			description: 'de servicios con DUT',
			breadcrumbs: 'Admin',
		},
		canActivate: [AdminGuardService],
		canLoad: [AdminGuardService],
		loadChildren: () => import('./modules/admin/admin.module').then(mod => mod.AdminModule),
	},

	{
		path: '**',
		redirectTo: 'home',
	},
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule],
	providers: [AuthGuardService],
})
export class AppRoutingModule {}
